// extracted by mini-css-extract-plugin
module.exports = {"select":"degreeSelect_select__2j2kY"};